import useSWR from "swr";

export const useFetchKuchikomyuOverallScoreAnswerCount = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: KuchikomyuOverallScoreAnswerCount, error, isLoading } = useSWR<number>(`kuchikomyu/overall-scores/count/?restaurantId=${restaurantId}&startDate=${startDate}&endDate=${endDate}`)
  return { KuchikomyuOverallScoreAnswerCount, isLoading, error };
};

